import { ICommandBarItemProps, Stack } from "@fluentui/react";
import { RouterParams } from "App";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import { EViewType } from "global/Application";
import { BuildVisibilityScope } from "global/Visibility/GlobalVisibility";
import { useEffect, useMemo, useState } from "react";
import { connect, ConnectedProps } from 'react-redux';
import { useParams } from "react-router-dom";
import BlueRelationshipContext from "./BlueRelationshipContext";
import FlexibleFieldView, { EScopeType } from "./FlexibleFieldView";
import GroupStructureGroupNumberView from "./GroupStructureGroupNumberView";
import StopLossProperties from "./StopLossProperties";

interface IProps extends TComponentConnectedProps {
}

const StopLoss = (props: IProps) => {
    const disabled = props.state.status.viewType !== EViewType.Modify;

    const params = useParams<RouterParams>();
    const [propertiesIsOpen, setPropertiesIsOpen] = useState(false);

    useEffect(() => {
        document.title = `Stop Loss`;

        if (stopLoss?.name)
            document.title = `Stop Loss | ${stopLoss?.name}`;

    }, []);

    const contextMenu = useMemo(() => {
        const items: ICommandBarItemProps[] = [];

        if (!disabled)
            items.push({
                key: 'feesAndPremiumsProperties',
                text: 'Properties',
                iconProps: { iconName: 'Settings' },
                onClick: () => setPropertiesIsOpen(true)
            });

        return { items: items, key: 'feesAndPremium' };
    }, [props.state.status.viewType]);

    const stopLoss = props.state?.data.json?.stopLoss?.find(q => q.id === params.stopLossId);
    const categoryStopLoss = props.state.data.config.cache?.map_bcbs_config_category_named['Stop Loss'];

    const controlVisibility = BuildVisibilityScope(
        null,
        props.state.data.json,
        null,
        null
    );

    return <BlueRelationshipContext contextMenu={contextMenu}>
        {stopLoss &&
            <>
                <StopLossProperties
                    isOpen={propertiesIsOpen}
                    onDismiss={() => setPropertiesIsOpen(false)}
                    data={{ stopLoss: stopLoss }}
                />

                <Stack>
                    <CustomPanel title={"Attributes"} canCollapse={true} defaultCollapsed={false} >
                        <FlexibleFieldView
                            disabled={props.state.status.viewType === EViewType.ViewOnly}
                            fields={stopLoss.fields}
                            category={categoryStopLoss}
                            tiers={[]}
                            scope={stopLoss}
                            visibility={controlVisibility}
                            scopeType={EScopeType.stopLoss}
                        />
                    </CustomPanel>

                    <CustomPanel title={"Group Numbers"}
                        canCollapse={true}
                        defaultCollapsed={true}
                        storageId={"stopLoss.groupNumbers"}
                        contentStyle={{ overflow: 'visible' }}
                    >
                        <div style={{ padding: '8px' }}></div>

                        <GroupStructureGroupNumberView
                            currentStopLoss={stopLoss}
                            disabled={disabled}
                        />
                    </CustomPanel>


                </Stack>
            </>
        }
    </BlueRelationshipContext>;
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(StopLoss)